import { normalizeCheckItems } from "@/service/checkFlag";
import { mergeSelectionSections } from "@/service/InspectionSelectionSync";
import { ActionContext, ActionTree, GetterTree } from "vuex";
import { OptionData } from "@/model/Option";
import { Utils } from "@/service/util";
import number from "@/shared/filters/Number";
// インスタンス生成
const utilsInstance = new Utils();

let serverSelection: any = null;

const initialState: OptionData = {
  option: {
    subTotalZn: 0,
    subTotalZk: 0
  },
  isConfirm: 0,
  waitAutoSave: 0
};
const actions: ActionTree<OptionData, any> = {
  setOptionFromServer({ commit }: ActionContext<OptionData, any>, payload: OptionData): void {
    commit("setOptionFromServer", payload);
  },
  setOptionFromSocket({ commit }: ActionContext<OptionData, any>, payload: OptionData): void {
    commit("setOptionFromSocket", payload);
  },
  setOption(
    { commit }: ActionContext<OptionData, any>,
    payload: OptionData
  ): void {
    commit("setOption", payload);
  },
  confirm({ commit }: ActionContext<OptionData, any>, payload: number): void {
    commit("confirm", payload);
  },
  autoSave({ commit }: ActionContext<OptionData, any>, payload: number): void {
    commit("autoSave", payload);
  },
  clearState({ commit }: ActionContext<OptionData, any>): void {
    commit("clearState");
  },
  updateSubTotal({ commit }: ActionContext<OptionData, any>, payload: any): void {
    commit("updateSubTotal", payload);
  }
};

const mutations = {
  setOptionFromServer(state: OptionData, payload: OptionData) {
    serverSelection = utilsInstance.deepCopy(payload);
    mutations.setOption(state, payload);
  },
  setOptionFromSocket(state: OptionData, payload: OptionData) {
    const snapshot = utilsInstance.deepCopy(payload);
    const merged = mergeSelectionSections(serverSelection, state, payload, ["option"]);
    mutations.setOption(state, merged);
    serverSelection = snapshot;
  },
  setOption(state: OptionData, payload: OptionData) {
    if (payload.option) {
      payload = { ...payload, option: { ...payload.option, items: normalizeCheckItems(payload.option.items) } };
    }
    state.optionOld = utilsInstance.deepCopy(state.option);
    Object.assign(state, payload);
  },
  confirm(state: OptionData, payload: number) {
    state.isConfirm = payload;
  },
  autoSave(state: OptionData, payload: number) {
    state.waitAutoSave = payload;
  },
  clearState(state: OptionData) {
    serverSelection = null;
    Object.assign(state, { ...initialState });
  },
  updateSubTotal(state: OptionData, payload: any) {
    if (state.option) {
      state.option.subTotalZk = payload.subTotalZk;
      state.option.subTotalZn = payload.subTotalZn;
    }
  }
};

const getters: GetterTree<OptionData, any> = {
  hasData(state: OptionData) {
    if (state.option && state.option.items) {
      return true;
    }
    return false;
  },
  currentState(state: OptionData) {
    return state;
  },
  listRunningKijuns(state: OptionData) {
    let stateCopy = utilsInstance.deepCopy(state);
    let domesticCar: any = [];
    let inportCar: any = [];
    if (stateCopy.runningWarranty && stateCopy.runningWarranty.kijunItems) {
      const { isInport, kijunItems } = stateCopy.runningWarranty;
      let i: number =0;
      for ( i=0; i< stateCopy.runningWarranty.kijunItems.length; i++ ) {
        if ( stateCopy.runningWarranty.kijunItems[i].isInport == 1 ) {
          domesticCar.push(stateCopy.runningWarranty.kijunItems[i]);
        } else {
          inportCar.push(stateCopy.runningWarranty.kijunItems[i]);
        }
      }
      return {domesticCar, inportCar};
    }
    return stateCopy;
  },
  hoshouPlanKey(state: OptionData) {
    let stateCopy = utilsInstance.deepCopy(state);
    let domesticCar: any = {};
    let inportCar: any = {};
    if (stateCopy.runningWarranty ) {
      domesticCar = {
        "key": "domesticCar",
        "name": "国産車",
        "class": "domestic-car"
      };
      inportCar = {
        "key": "inportCar",
        "name": "輸入車",
        "class": "inport-car"
      };
      // 絞り込み出来ているときは片方、不明なら両方を配列で返す
      if ( stateCopy.runningWarranty.isInport == 1 ) {
        return [domesticCar];
      } else if ( stateCopy.runningWarranty.isInport == 2 ) {
        return [inportCar];
      } else {
        return [domesticCar, inportCar];
      }
    }
    return [domesticCar, inportCar];
  },
  listPeriods(state: OptionData) {
    let stateCopy = utilsInstance.deepCopy(state);
    let dummy: any = [];
    if (stateCopy.runningWarranty && stateCopy.runningWarranty.periodItems) {
      return stateCopy.runningWarranty.periodItems;
    }
    return dummy;
  },
  listWarranties(state: OptionData) {
    let stateCopy = utilsInstance.deepCopy(state);

    // 配列の用意
    let nodes: any = {
      "key": 0,
      "priceZk": 0,
      "priceZn": 0
    };
    let nodeDomesticCar: any = [];
    let nodeInportCar: any = [];
    let domesticCar: any = [];
    let inportCar: any = [];
    let i: number =0;
    if (stateCopy.runningWarranty ) {
      const { kijunItems , periodItems } = stateCopy.runningWarranty;
      

      // 国産車輸入車のラベル数を確認
      let domesticCount: number =0;
      let inportCarCount: number =0;
      for ( i=0; i< kijunItems.length; i++ ) {
        if ( kijunItems[i].isInport == 1 ) {
          domesticCount++;
        } else {
          inportCarCount++;
        }
      }

      // ラベルを元に配列マップを作る
      for ( i=0; i< domesticCount; i++ ) {
        nodeDomesticCar[i] = utilsInstance.deepCopy(nodes);
      }
      for ( i=0; i< inportCarCount; i++ ) {
        nodeInportCar[i] = utilsInstance.deepCopy(nodes);
      }
      for ( i=0; i< periodItems.length; i++ ) {
        domesticCar[i] = utilsInstance.deepCopy(nodeDomesticCar);
        inportCar[i] = utilsInstance.deepCopy(nodeInportCar);
      }
    }

    // オプションリストの配置
    if (stateCopy.option && stateCopy.option.items) {
      for ( i=0; i< stateCopy.option.items.length; i++ ) {
        let setData = stateCopy.option.items[i];
        if ( setData.warrantyKbn == 1 ) {
          if (setData.isInport == 1) {
            domesticCar[setData.periodCd][setData.kijunCd].key = setData.optionId;
            domesticCar[setData.periodCd][setData.kijunCd].priceZk = setData.kingakuZk;
            domesticCar[setData.periodCd][setData.kijunCd].priceZn = setData.kingakuZn;
          } else {
            inportCar[setData.periodCd][setData.kijunCd].key = setData.optionId;
            inportCar[setData.periodCd][setData.kijunCd].priceZk = setData.kingakuZk;
            inportCar[setData.periodCd][setData.kijunCd].priceZn = setData.kingakuZn;
          }
        }
      }
    }

    return {domesticCar, inportCar};
  },

  listTires(state: OptionData) {
    let stateCopy = utilsInstance.deepCopy(state);
    let dummy: any = [];
    let i: number =0;
    let listTires: any = [];
    if (stateCopy.tireWarranty && stateCopy.tireWarranty.tireItems) {
      listTires = utilsInstance.deepCopy(stateCopy.tireWarranty.tireItems);
      for ( i=0; i< stateCopy.tireWarranty.tireItems.length; i++ ) {
        listTires[i].num = stateCopy.tireWarranty.tireItems[i].optionId;// 退避
        listTires[i].key = 0;
      }

      // オプションリストの配置
      if (stateCopy.option && stateCopy.option.items) {
        for ( i=0; i< stateCopy.option.items.length; i++ ) {
          let setData = stateCopy.option.items[i];
          if ( setData.warrantyKbn == 2 ) {
            let j: number =0;
            for ( j=0; j< listTires.length; j++ ) {
              if ( listTires[j].optionId == setData.tireCd ) {
                listTires[j].key = setData.optionId;
              }
            }
          }
        }
      
      
      }

      return listTires;
    }
    return dummy;
  },


  listEtcOptions(state: OptionData) {
    let stateCopy = utilsInstance.deepCopy(state);



    
    let listTarget: any = [];
    if (stateCopy.option && stateCopy.option.items) {
      const { items } = stateCopy.option;
      let i: number =0;
      for ( i=0; i< items.length; i++ ) {
        if ( items[i].warrantyKbn != 1 && items[i].warrantyKbn != 2 ) {
          listTarget.push(items[i]);
        }
      }
      return listTarget;
    }
    return stateCopy;
  },







  total(state: OptionData) {
    if (state.option) {
      const { subTotalZn, subTotalZk, items } = state.option;
      return { subTotalZn, subTotalZk, isConfirm: state.isConfirm, items };
    }
    return null;
  },
  waitingAutoSave(state: OptionData) {
    return state.waitAutoSave;
  },
  isConfirm(state: OptionData) {
    return state.isConfirm;
  }
};

const namespaced: boolean = true;
export default {
  namespaced,
  state: { ...initialState },
  getters,
  actions,
  mutations
};

